// Components==============
import ArrowButtons from 'components/UI/ArrowButtons/ArrowButtons';
import Avatar from 'components/UI/Avatar/Avatar';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import ProcessInfo from 'components/UI/ProcessInfo/ProcessInfo';
import ToggleAllButton from 'pages/Growth/Reflect/components/Top/ToggleAllButton';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import React, { useContext } from 'react';
import { ReflectContext } from '../../Reflect';
import CheckpointInfo from './CheckpointInfo/CheckpointInfo';
import MemberBar from './MemberBar/MemberBar';
import './Top.module.scss';
// =========================

export default function Top() {
  const {
    selectedStudent,
    setSelectedStudent,
    sortedStudentList,
    wrapperRef,
    processGroups,
    project,
    checkpointGroup,
    peerId,
  } = useContext(ReflectContext);

  const isTeacher = usePermission(['Docent', 'super-admin', 'Extern']);

  // // filter out student and teachers
  const students = sortedStudentList.filter(
    (member) => member.membership === 'member' || member.membership === 'owner'
  );

  const peerReflection = useRedux((state) =>
    peerId ? state.reflection?.entities.byId[parseInt(peerId)] : undefined
  );

  if (peerId)
    return (
      <div styleName="wrapper peer-reflection">
        <Avatar user={peerReflection?.for_user} />
        <div>
          <p>Peerreflectie op</p>{' '}
          <h3>
            {peerReflection?.for_user?.first_name}{' '}
            {peerReflection?.for_user?.last_name}
          </h3>
        </div>
      </div>
    );

  return (
    <div styleName={`wrapper ${isTeacher ? 'teacher' : 'student'}`}>
      <div styleName="left ">
        <div styleName="row">
          {!!(!isTeacher && (project?.members.length || 0) > 1) && (
            <MemberBar />
          )}
          {isTeacher &&
            (students.length === 1 ? (
              <MemberBar />
            ) : (
              <div styleName="student-selector">
                <Dropdown
                  initialOptions={sortedStudentList.map((sl) => sl.name)}
                  initialText={selectedStudent}
                  selectedItem={selectedStudent}
                  setSelectedItem={setSelectedStudent}
                />
              </div>
            ))}
          {checkpointGroup ? (
            <CheckpointInfo />
          ) : (
            <ProcessInfo processGroups={processGroups} />
          )}
        </div>
      </div>
      <div styleName="right">
        {checkpointGroup === undefined && !isTeacher ? null : (
          <ArrowButtons color="white" reference={wrapperRef} />
        )}
        {checkpointGroup === undefined && !isTeacher ? null : (
          <ToggleAllButton />
        )}
      </div>
    </div>
  );
}
